import * as BABYLON from "babylonjs";
import "babylonjs-loaders/babylonjs.loaders.min.js";
import { EventBus } from "./EventBus";
//https://blog.csdn.net/weixin_45727272/article/details/108098667
// var assetsManager = new BABYLON.AssetsManager(scene);
// var meshTask = assetsManager.addMeshTask("skull task", "", "scenes/", "skull.babylon");
export class Loader extends EventBus {
  loadingStat = "";
  loadingRes = true;
  cache = {};
  constructor() {
    if (!Loader.instance) {
      super();
      this.name = null;
      Loader.instance = this;
    }
    return Loader.instance;
  }
  static getInstance() {
    if (!this.instance) {
      return (this.instance = new Loader());
    }
    return this.instance;
  }
  async load(scene, path, name, cachename) {
    return new Promise((reslove, reject) => {
      this.cache[cachename] = 'loading'
      BABYLON.SceneLoader.LoadAssetContainer(
        path,
        name,
        scene,
        container => {
          //onSuccess
          this.cache[cachename] = container;
          // "一体1列1簇":"product1",
          // "一体2列1簇":"product2",
          // "一体箱式":"product3",
          // "一体箱式22簇":"product6",
          // "分体电池仓3簇":"product4",
          // "分体电池仓箱式":"product5",
          // "功率仓":"powerBox",
          // "电气仓":"electricalBox",
          // "风车":"wind",
          // "停车":"park",
          // "光伏":"light",
          // "电塔":"tower",
          if (name === "park.glb") {
            this.cache[cachename].meshes[1].material.albedoColor = new BABYLON.Color3(1,1,1)
          }else{
            this.cache[cachename].meshes[1].material.albedoColor = new BABYLON.Color3(.8,.8,.8)

          }
          reslove(container);
        },
        e => {
          //onProgress
          // console.log(e.total, e.loaded, path, name);
        },
        (scene, e) => {
          //onError
          console.error(e, this);
          this.loadingRes = false;
          reject(false);
        }
      );
    });
  }
  async loads(scene, objs) {
    this.loadingStat = "ing";
    // console.log('loadingStart');
    let promiseArr = [];
    for (let index = 0; index < objs.length; index++) {
      if (objs[index].type === "d") {
        promiseArr.push(
          this.load(
            scene,
            objs[index].path,
            objs[index].type + objs[index].name,
            objs[index].name
          )
        );
      } else {
        promiseArr.push(
          this.load(scene, objs[index].path, objs[index].name, objs[index].name)
        );
      }
    }
    let res = await Promise.all(promiseArr).catch(function(reason) {
      console.log("promise reject failed reason", reason);
    });
    // console.log(res);
    this.loadingStat = "over";
    this.$emit("loadover");
    // console.log('loadover');
    return this.loadingRes;
  }

  end() {
    return new Promise(resolve => {
      if (this.loadingStat === "over" && this.loadingRes) {
        resolve(true);
      }
      this.$on("loadover", function() {
        resolve(true);
      });
    });
  }
  async loadOne(scene, path, name) {
    return new Promise((reslove, reject) => {
      if (this.cache[name]) {
        reslove(this.cache[name]);
      }
      BABYLON.SceneLoader.LoadAssetContainer(
        path,
        name,
        scene,
        function(container) {
          //onSuccess
          this.cache[name] = container;
          reslove(container);
        },
        function(e) {
          //onProgress
          console.log(e.total, e.loaded, path, name);
        },
        function(e) {
          //onError
          console.error(e);
          reject(e);
        }
      );
    });
  }
  loadhdrenv(url, scene) {
    return new Promise(resolve => {
      const g = new BABYLON.HDRCubeTexture(
        url,
        scene,
        256,
        false,
        true,
        false,
        true
      );
      g.gammaSpace = !1;
      scene.createDefaultSkybox(g, !0, 1000, 0);
      scene.environmentTexture = g;
      resolve(1);
    });
  }
  loadenv(url, scene) {
    return new Promise(resolve => {
      let g = BABYLON.CubeTexture.CreateFromPrefilteredData(url, scene);
      g.gammaSpace = !1;
      // scene.createDefaultSkybox(g, !0, 1000, 0.3);
      scene.environmentTexture = g;
      resolve(1);
    });
  }

  //gltf =》 draco
  // draco3d  npm
  //https://github.com/google/draco/tree/master/javascript
  //https://www.npmjs.com/package/draco3dgltf
  //https://github.com/ouyangzhaoxing/drcobj
  //https://github.com/juriy/draco

  async loadDraco(scene, path, name) {
    return new Promise(resolve => {
      BABYLON.Tools.LoadFile(
        path + name,
        async function(data) {
          var dracoCompression = new BABYLON.DracoCompression();
          var attributes = {
            // [BABYLON.VertexBuffer.UVKind]: 0,
            // [BABYLON.VertexBuffer.NormalKind]: 1,
            // [BABYLON.VertexBuffer.TangentKind]: 2,
            // [BABYLON.VertexBuffer.PositionKind]: 3
          };

          var vertexData = await dracoCompression.decodeMeshAsync(
            data,
            attributes
          );
          var mesh = new BABYLON.Mesh(name, scene);
          var geometry = new BABYLON.Geometry(
            "geometry" + name,
            scene,
            vertexData,
            undefined,
            mesh
          );
        },
        undefined,
        undefined,
        true
      );
      resolve(123);
    });
  }

  delayCreateScene = function() {
    BABYLON.Tools.LoadFile(
      "https://raw.githubusercontent.com/KhronosGroup/glTF-Sample-Models/master/2.0/BarramundiFish/glTF-Draco/0.bin",
      async function(data) {
        var dracoCompression = new BABYLON.DracoCompression();

        var attributes = {
          // [BABYLON.VertexBuffer.UVKind]: 0,
          // [BABYLON.VertexBuffer.NormalKind]: 1,
          // [BABYLON.VertexBuffer.TangentKind]: 2,
          [BABYLON.VertexBuffer.PositionKind]: 3
        };

        var vertexData = await dracoCompression.decodeMeshAsync(
          data,
          attributes
        );
        var mesh = new BABYLON.Mesh("dracoMesh", scene);
        var geometry = new BABYLON.Geometry(
          "dracoGeometry",
          scene,
          vertexData,
          undefined,
          mesh
        );

        mesh.material = new BABYLON.PBRMaterial("material", scene);
        mesh.material.sideOrientation =
          BABYLON.Material.CounterClockWiseSideOrientation;
        mesh.material.metallic = 0;

        scene.createDefaultCameraOrLight(true, undefined, true);
      },
      undefined,
      undefined,
      true
    );

    return scene;
  };
}



// WEBPACK FOOTER //
// ./src/components/webgl/LevelsShow/Loader.js